<template>
  <panel :title="title" :withBody="isDisplayDetails || showCardInfoStatus" :withFooter="isDisplayDetails" :to="getTitleLink()" :titleCustomClass="'l-col-8@md'">
    <div slot="header-right">
      <modal-product-action-reprocess slot="panel-section" :product="product" :typeAction="typeAction" v-model="modalProductActionReprocessFlag" v-on:confirm="productActionReprocess(typeAction)"/>
      <modal-remove-product slot="panel-section" :product="product" :module="module" v-model="modalRemoveProductFlag" v-on:confirm="removeProduct()"/>
      <modal-deactivate-product slot="panel-section" :product="product" v-model="modalDeactivateProductFlag" v-on:confirm="deactivateProduct()"/>
      <modal-reactivate-product slot="panel-section" :product="product" v-model="modalReactivateProductFlag" v-on:confirm="reactivateProduct()"/>
      <modal-delete-product slot="panel-section" :product="product" v-model="modalDeleteProductFlag" v-on:confirm="deleteProduct()"/>
      <modal-resend-product slot="panel-section" :product="product" v-model="modalResendProductFlag" v-on:confirm="resendProduct()"/>
      <modal-reprocess-images slot="panel-section" :product="product" v-model="modalReprocessImagesFlag" v-on:confirm="reprocessImages()"/>
      <span v-if="isDisplayList"  class="statusDetails status " :class="product.saleAvailability">Disp. de venda</span>
      <span v-if="isDisplayList"  class="statusDetails status hint hint--left" :class="product.stock.status" :data-label="getLastSyncMessage(product.stock.date)">Estoque</span>
      <span v-if="isDisplayList"  class="statusDetails status hint hint--left" :class="product.price.status" :data-label="getLastSyncMessage(product.price.date)">Preço</span>
      <span v-if="isDisplayList && product.hasOwnProperty('imageStatus')"  class="statusDetails status" :class="product.imageStatus">Imagem</span>
      <span class="badge statusDetails status hint hint--left" :data-label="getLastSyncMessage(product.date)" :class="product.status">
        {{ $te(`${module.identifier}.status.${product.status}.label`) ? $t(`${module.identifier}.status.${product.status}.label`) : $t(`${product.status}.label`) }}
      </span>

      <button-actions :identifier="`product-item-actions-${product._id.$oid}`">
        <li v-if="getTitleLink()">
          <router-link :to="getTitleLink()">Editar</router-link>
        </li>
        <li v-if="product.message || product.price.message || product.stock.message || product.imageErrorMessage || product.imageStatusMessage">
          <span @click="showInfoStatusMessage">Ver mensagens</span>
        </li>
        <li v-if="product.salesChannel !== undefined && product.salesChannel.length">
          <span @click="showSaleChannelPriceModal">Preços por canal de venda</span>
          <modal-sales-channel-price v-model="saleChannelPriceModal" :salesChannel="product.salesChannel"/>
        </li>
        <li v-if="product.status === 'approved' && (this.module.identifier === 'gfg' || this.module.identifier === 'amazon')">
          <span @click="modalProductActionReprocessFlag = true, typeAction = 'product'">Reprocessar produto</span>
        </li>
        <li v-if="product.status === 'approved'">
          <span @click="modalProductActionReprocessFlag = true, typeAction = 'stock'">Reprocessar estoque</span>
        </li>
        <li v-if="product.status === 'approved'">
          <span @click="modalProductActionReprocessFlag = true, typeAction = 'price'">Reprocessar preço</span>
        </li>
        <li v-if="product.status === 'approved'">
          <span @click="modalReprocessImagesFlag = true">Reprocessar imagem</span>
        </li>
        <li v-if="(product.status !== 'error' && this.module.identifier !== 'cnova') || (this.module.identifier === 'cnova' && product.status === 'approved' && product.saleAvailability === 'available')">
          <span @click="modalDeactivateProductFlag = true">Indisponibilizar produto</span>
        </li>
        <li>
          <span @click="modalRemoveProductFlag = true">Remover produto</span>
        </li>
        <li v-if="this.module.identifier === 'cnova' && product.status !== 'error' && product.saleAvailability !== 'available'">
          <span @click="modalReactivateProductFlag = true">Reativar produto</span>
        </li>
        <li v-if="this.module.identifier === 'cnova' && (product.status === 'approved' || product.status === 'denied')">
          <span @click="modalDeleteProductFlag = true">Excluir produto</span>
        </li>
        <li v-if="this.module.identifier === 'shopee' && product.status === 'deleted'">
          <span @click="modalResendProductFlag = true">Reenviar produto</span>
        </li>
      </button-actions>
    </div>
    <div>

      <div class="l-row" v-show="showCard">
          <div class="l-col-2@md img-product">
            <img :src="image" class="img-rounded" v-if="image"/>
            <i class="icon icon-image2 no-photo" v-else></i>
          </div>

          <blockquote class="l-col-3@md box">
            <div class="l-row attributes">
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>SKU</strong>
                  {{ product.sku | attribute }}
                </div>
              </div>
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>EAN</strong>
                  {{ product.ean | attribute }}
                </div>
              </div>
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>Marca</strong>
                  {{ product.brand | attribute }}
                </div>
              </div>
              <div class="l-col-6@md" v-if="product.productId">
                <div class="margin">
                  <strong>{{ $t('productGroupedId.label') }}</strong>
                  {{ product.productId | attribute }}
                </div>
              </div>
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>{{ $t('createdAt.label') }}</strong>
                  {{ product.createdAt | moment('DD/MM/YYYY HH:mm') | attribute }}
                </div>
                <div class="margin" v-if="product.account">
                  <strong>Conta</strong>
                  {{ product.account.identifier }}
                </div>
              </div>
              <slot name="attributes"/>
            </div>
          </blockquote>

          <slot name="custom-column"></slot>

          <blockquote class="l-col-2@md box">
            <div class="l-row">
              <div class="l-col-6@md attributes">
                <div class="margin">
                  <strong>{{ $t('stock.label') }}</strong>
                  {{ product.stock.quantity | attribute }}
                </div>
                <div class="margin">
                  <strong>{{ $t('reducer.label') }}</strong>
                  {{ product.stock.reducer | attribute }}
                </div>
              </div>
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>Status Estoque</strong>
                  <span class="status hint hint--left" :class="product.stock.status" :data-label="getLastSyncMessage(product.stock.date)">{{ $t(product.stock.status).label }}</span>
                </div>

                <div class="margin">
                  <strong>Disp. de venda</strong>
                  <span class="status" :class="product.saleAvailability">{{ $t(`saleAvailability.${product.saleAvailability}.label`) }}</span>
                </div>
              </div>
            </div>
          </blockquote>

          <blockquote class="l-col-3@md box">
            <div class="l-row vertical-flex">
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>{{ $t('type.label') }}</strong>
                  {{ $t(product.price.type).label }}
                </div>
                <div class="margin">
                  <strong>{{ $t('price.previous.label') }}</strong>
                  {{ product.price.previous | currency }}
                </div>
                <div class="margin" v-if="isMarginPriceType">
                  <strong>{{ $t(`price.${product.price.type}.auxiliary.label`) }}</strong>

                  <span v-if="!isMarginPriceType">{{ product.price.auxiliary }}</span>
                  <editable v-else :label="$t(`price.${product.price.type}.auxiliary.label`)" :type="product.price.type === 'percent' ? 'percent' : 'price'" v-model="product.price.auxiliary" :onConfirm="confirmedUpdateAuxiliary"/>
                </div>
              </div>
              <div class="l-col-6@md">
                <div class="margin">
                  <strong>Status Preço</strong>
                  <span
                    class="status hint hint--left"
                    v-bind:class="{
                      [product.price.status]: true,
                      'margin-price': isMarginPriceType
                    }"
                    :data-label="getLastSyncMessage(product.price.date)">{{ $t(product.price.status).label }}
                  </span>
                </div>
                <div class="margin">
                  <strong>{{ $t('price.current.label') }}</strong>

                  <span v-if="!isAllowUpdatePrice">{{ product.price.current | currency }}</span>
                  <editable v-else :label="$t('price.current.label')" type="price" v-model="product.price.current" :onConfirm="confirmedUpdatePrice"/>
                </div>
              </div>
            </div>
          </blockquote>
      </div>

      <transition name="fade">
        <status-message-card v-if="showCardInfoStatus" :product="product" :module="module" v-on:close="showInfoStatusMessage()"/>
      </transition>
    </div>
    <div slot="footer">
      <module-icon :identifier="product.source.identifier"/>
    </div>
  </panel>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import ModuleIcon from '@/components/template/ModuleIcon'
  import StatusMessageCard from '@/components/shared/StatusMessageCard'
  import ModalSalesChannelPrice from '@/components/marketplace/shared/ModalSalesChannelPrice'
  import ModalProductActionReprocess from '@/components/marketplace/shared/ModalProductActionReprocess'
  import ModalDeactivateProduct from '@/components/marketplace/shared/ModalDeactivateProduct'
  import ModalRemoveProduct from '@/components/marketplace/shared/ModalRemoveProduct'
  import ModalReprocessImages from '@/components/marketplace/shared/ModalReprocessImages'
  import ModalReactivateProduct from '@/components/marketplace/shared/ModalReactivateProduct'
  import ModalDeleteProduct from '@/components/marketplace/shared/ModalDeleteProduct'
  import ModalResendProduct from '@/components/marketplace/shared/ModalResendProduct'
  import Panel from '../../template/Panel'
  import moment from 'moment'
  import ButtonActions from '@/components/template/ButtonActions'
  import Editable from '@/components/template/Editable/Base'
  import api from '@/api'
  import notifier from '@/notifier'

  export default {
    inject: ['module'],
    data: () => ({
      showCard: true,
      showCardInfoStatus: false,
      title: null,
      saleChannelPriceModal: false,
      modalProductActionReprocessFlag: false,
      modalReactivateProductFlag: false,
      modalDeactivateProductFlag: false,
      modalRemoveProductFlag: false,
      modalDeleteProductFlag: false,
      modalResendProductFlag: false,
      modalReprocessImagesFlag: false,
      typeAction: null,
      loading: false,
      reason: null
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      image: {
        type: String,
        required: false
      },
      module: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.detailsProduct()
    },
    methods: {
      showInfoStatusMessage () {
        this.showCard = !this.showCard
        this.showCardInfoStatus = !this.showCardInfoStatus
      },
      showCardProduct () {
        this.showCardInfoStatus = false
        this.showCard = true
      },
      getLastSyncMessage (date) {
        const formatted = moment(date).format('DD/MM/YYYY HH:mm')
        return `Sincronizado em ${formatted}`
      },
      getTitleLink () {
        if (this.product.status === 'approved') {
          const sku = encodeURIComponent(this.product.sku)

          return { path: `/marketplace/${this.module.identifier}/products/${sku}`, params: { identifier: this.module.identifier, sku: sku } }
        }

        if (this.module.identifier === 'cnova' && this.product.status === 'denied') {
          const sku = encodeURIComponent(this.product.sku)

          return { path: `/marketplace/${this.module.identifier}/products/${sku}`, params: { identifier: this.module.identifier, sku: sku } }
        }

        return null
      },
      detailsProduct () {
        let title = []

        if (this.product.title) {
          title.push(this.product.title.length > 120 ? this.product.title.substring(0, 120).replace('-', '').trim() + '...' : this.product.title)
        }
        if (this.listInitial === 'displayList') {
          if (this.product.sku) {
            title.push(`Sku: ${this.product.sku}`)
          }

          if (this.product.ean) {
            title.push(`Ean: ${this.product.ean}`)
          }

          if (this.product.color) {
            title.push(`Cor: ${this.product.color}`)
          }

          if (this.product.grid) {
            title.push(`Tamanho: ${this.product.grid}`)
          }

          if (this.product.crossDocking !== null && this.product.crossDocking.quantity !== null) {
            title.push(`Prazo extra: ${this.product.crossDocking.quantity}`)
          }

          if (this.product.attributes) {
            if (this.product.attributes.color) {
              title.push(`Cor: ${this.product.attributes.color}`)
            }

            if (this.product.attributes.size) {
              title.push(`Tamanho: ${this.product.attributes.size}`)
            }

            if (this.product.attributes.crossDocking) {
              title.push(`Prazo extra: ${this.product.attributes.crossDocking}`)
            }
          }
        }

        this.title = title.join(' | ')
      },
      confirmedUpdatePrice (previousValue, newValue) {
        this.loading = true

        this.product.price.current = newValue

        const product = cloneDeep(this.product)
        product._id = product._id.$oid

        if (product.price.previous < product.price.current) {
          product.price.previous = 0
        }

        api.updateProductPrice(this.module.type, this.module.identifier, product)
          .then(product => {
            this.product.price.previous = product.price.previous
            this.product.price.status = product.price.status

            notifier.success('Preço do produto atualizado com sucesso.', 'Atualização de preço')
          })
          .catch(() => {
            this.product.price.current = previousValue

            notifier.error('Erro na atualização de preço do produto.', 'Erro')
          })
          .finally(() => { this.loading = false })
      },
      confirmedUpdateAuxiliary (previousValue, newValue) {
        this.loading = true

        this.product.price.auxiliary = newValue

        const product = cloneDeep(this.product)
        product._id = product._id.$oid

        api.updateProductPrice(this.module.type, this.module.identifier, product)
          .then(product => {
            this.product.price.status = product.price.status
            this.product.price.previous = product.price.previous
            this.product.price.current = product.price.current

            notifier.success('Preço do produto atualizado com sucesso.', 'Atualização de preço')
          })
          .catch(() => {
            this.product.price.auxiliary = previousValue

            notifier.error('Erro na atualização de preço do produto.', 'Erro')
          })
          .finally(() => { this.loading = false })
      },
      showSaleChannelPriceModal () {
        this.saleChannelPriceModal = true
      },
      async productActionReprocess (typeAction) {
        this.loading = true

        const options = {
          type: typeAction,
          identifier: this.product.sku
        }

        await api.reprocess(this.module.type, this.module.identifier, options)
          .then((productReprocessed) => {
            this.modalProductActionReprocessFlag = false

            if (typeAction === 'product') {
              this.product.status = productReprocessed.status
            }

            if (typeAction === 'price') {
              this.product.price.status = productReprocessed.price.status
            }

            if (typeAction === 'stock') {
              this.product.stock.status = productReprocessed.stock.status
            }
            notifier.success('Produto enviado para a fila de processamento.', 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao enviar produto para fila de processamento.'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
            this.typeAction = null
          })
      },
      async deactivateProduct () {
        this.loading = true

        const product = {
          sku: this.product.sku
        }

        await api.deactivateProduct(this.module.type, this.module.identifier, product)
          .then((productReprocessed) => {
            this.modalDeactivateProductFlag = false

            this.product.status = productReprocessed.status

            this.product.saleAvailability = productReprocessed.saleAvailability

            let message = 'Produto indisponibilizado com sucesso!'

            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao indisponibilizar o produto!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })
      },
      async removeProduct () {
        this.loading = true
        let successRemove = false
        const product = {
          sku: this.product.sku
        }

        await api.removeProduct(this.module.type, this.module.identifier, product)
          .then((productReprocessed) => {
            this.modalRemoveProductFlag = false

            this.product.status = productReprocessed.status

            this.product.saleAvailability = productReprocessed.saleAvailability

            let message = 'Produto removido com sucesso!'

            notifier.success(message, 'Sucesso')
            successRemove = true
          })
          .catch(error => {
            let message = 'Falha ao remover o produto!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })

        if (successRemove === true) {
          await new Promise(resolve => setTimeout(resolve, 2000))
          window.location.reload()
        }
      },
      async reactivateProduct () {
        this.loading = true
        const product = {
          sku: this.product.sku
        }
        await api.reactivateProduct(this.module.type, this.module.identifier, product)
          .then((productReprocessed) => {
            this.modalReactivateProductFlag = false
            this.product.status = productReprocessed.status
            let message = 'Produto reativado com sucesso! Dentro de alguns instantes o mesmo será atualizado no Marketplace'
            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao indisponibilizar o produto!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })
      },
      async resendProduct () {
        this.loading = true

        const product = {
          sku: this.product.sku
        }

        await api.resendProduct(this.module.type, this.module.identifier, product)
          .then((productReprocessed) => {
            this.modalResendProductFlag = false

            this.product.status = productReprocessed.status

            let message = 'Produto disponível para reenvio com sucesso!'

            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao reenviar o produto!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })
      },
      async reprocessImages () {
        this.loading = true

        const product = {
          sku: this.product.sku
        }

        await api.reprocessImages(this.module.type, this.module.identifier, product)
          .then((productReprocessed) => {
            this.modalReprocessImagesFlag = false

            this.product.imageStatus = productReprocessed.imageStatus

            let message = 'Imagens do produto enviadas para fila com sucesso!'

            notifier.success(message, 'Sucesso')
          })
          .catch(error => {
            let message = 'Falha ao reprocessar imagens do produtos!'
            if (error.response.data.message) {
              message = error.response.data.message
            }
            notifier.error(message, 'Erro')
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    computed: {
      isDisplayList () {
        return this.listInitial === 'displayList'
      },
      isDisplayDetails () {
        return this.listInitial === 'displayDetails'
      },
      listInitial () {
        return this.$parent.$parent.listInitial
      },
      isAllowUpdatePrice () {
        if (this.product.price.type === 'custom') {
          return true
        }

        return false
      },
      isMarginPriceType () {
        return ['percent', 'fixedValue'].indexOf(this.product.price.type) !== -1
      }
    },
    watch: {
      listInitial () {
        this.detailsProduct()
      }
    },
    components: {
      ModalSalesChannelPrice,
      ModalProductActionReprocess,
      ModalDeactivateProduct,
      ModalRemoveProduct,
      ModalReprocessImages,
      Panel,
      ModuleIcon,
      StatusMessageCard,
      ButtonActions,
      Editable,
      ModalReactivateProduct,
      ModalDeleteProduct,
      ModalResendProduct
    }
  }
</script>

<style lang="sass" scoped>
  .img-product
    text-align: center

    img
      max-width: 100%
      margin:  5px 0 16px
      max-height: 150px
      vertical-align: middle

  .notsent
    filter: grayscale(100%)

  .title
    text-align: center
    color: white
    font-weight: bold
    font-size: 16px

  .icon-size
    font-size: 14px

  .blocksize
    display: table
    height: 100%
    width: 100%

  .ul-align
    margin-top: 15px

  .status
    width: 100%
    text-align: center
    font-size: 12px
    padding: 4px 8px
    line-height: 1
    vertical-align: middle
    display: block

  .margin-price
    margin-bottom: 20px

  .statusDetails
    display: inline

  .no-photo
    font-size: 150px
    color: #a9a9a9
    margin: 5px 0 16px

  strong
    display: block
    margin-bottom: 5px

  .margin
    margin: 10px 0 15px 10px

  .fade-enter-active
    transition: opacity .7s

  .fade-enter
    opacity: 0

  .btn-icon
    float: right

  img
    margin-top: 5px

  .btn--warning
    margin-left: 3px

</style>



// WEBPACK FOOTER //
// ProductCard.vue?1746dab8